import { send } from 'server';

export const sendVerificationEmail = ({ template, casinoName }) => send({
    ID: 35559,
    responses: [35560, 35561],
    description: 'send verification email',
    sendMail: 1,
    casinoName,
    ...template ? { template } : {}
});
